'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateShowHideSuggestionsModal = updateShowHideSuggestionsModal;
exports.updateShouldRefreshSuggestions = updateShouldRefreshSuggestions;
exports.updateShowOnBoardingBeacon = updateShowOnBoardingBeacon;
exports.updateHasMoreSuggestions = updateHasMoreSuggestions;
exports.shouldCheckForFollowingTeamUpdates = shouldCheckForFollowingTeamUpdates;
exports.updateFollowingTeamStatus = updateFollowingTeamStatus;
exports.updateShowTeammates = updateShowTeammates;
exports.checkForFollowingTeamUpdates = checkForFollowingTeamUpdates;
exports.getSuggestedAthletes = getSuggestedAthletes;
exports.getSearchAthletes = getSearchAthletes;
exports.followUnfollowTeam = followUnfollowTeam;

var _services = require('../../utils/services');

var _services2 = _interopRequireDefault(_services);

var _actionTypes = require('./action-types');

var _actionCreators = require('./action-creators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function failReceivedSuggestedAthlete() {
  return {
    type: _actionTypes.FAIL_RECEIVE_SUGGESTED_ATHLETES,
    payload: {}
  };
}

function failReceivedSearchAthletes() {
  return {
    type: _actionTypes.FAIL_RECEIVE_SEARCH_ATHLETES,
    payload: {}
  };
}

function failFollowTeam() {
  return {
    type: _actionTypes.FAIL_FOLLOW_TEAM,
    payload: {}
  };
}

function failUnfollowTeam() {
  return {
    type: _actionTypes.FAIL_UNFOLLOW_TEAM,
    payload: {}
  };
}

function updateIsFetchingStatus(type, isFetching) {
  return {
    type: type,
    payload: {
      isFetching: isFetching
    }
  };
}

function receiveSearchAthletes(searchAthletes, query, isSearching) {
  return {
    type: _actionTypes.SUCCESS_GET_SEARCH_ATHLETES,
    payload: {
      searchAthletes: searchAthletes,
      isSearching: isSearching,
      query: query
    }
  };
}

function receiveModalSearchAthletes(modalSearchAthletes, query) {
  return {
    type: _actionTypes.SUCCESS_MODAL_GET_SEARCH_ATHLETES,
    payload: {
      modalSearchAthletes: modalSearchAthletes,
      query: query
    }
  };
}

function receiveSuggestedAthletes(suggestedAthletes, maxScore) {
  return {
    type: _actionTypes.SUCCESS_GET_SUGGESTED_ATHLETES,
    payload: {
      suggestedAthletes: suggestedAthletes,
      maxScore: maxScore
    }
  };
}

function receiveModalSuggestedAthletes(modalSuggestedAthletes) {
  return {
    type: _actionTypes.SUCCESS_MODAL_GET_SUGGESTED_ATHLETES,
    payload: {
      modalSuggestedAthletes: modalSuggestedAthletes
    }
  };
}

function receiveTeammates(teammates, hasMoreTeammates, showTeammates) {
  return {
    type: _actionTypes.SUCCESS_GET_TEAMMATES,
    payload: {
      teammates: teammates,
      showTeammates: showTeammates,
      hasMoreTeammates: hasMoreTeammates
    }
  };
}

function updateShowHideSuggestionsModal(shouldShowModal) {
  return {
    type: _actionTypes.UPDATE_DISPLAY_SUGGESTIONS_MODAL,
    payload: {
      shouldShowModal: shouldShowModal
    }
  };
}

function updateShouldRefreshSuggestions(refreshSuggestions) {
  return {
    type: _actionTypes.UPDATE_SHOULD_REFRESH_SUGGESTIONS,
    payload: {
      refreshSuggestions: refreshSuggestions
    }
  };
}

function updateShowOnBoardingBeacon(showOnboardingBeacon) {
  return {
    type: _actionTypes.UPDATE_SHOW_ONBOARDING_BEACON,
    payload: {
      showOnboardingBeacon: showOnboardingBeacon
    }
  };
}

function updateHasMoreSuggestions(newValue) {
  return {
    type: _actionTypes.UPDATE_HAS_MORE_SUGGESTIONS,
    payload: {
      newValue: newValue
    }
  };
}

function shouldCheckForFollowingTeamUpdates(newValue) {
  return {
    type: _actionTypes.SHOULD_UPDATE_FOLLOWING_STATUS,
    payload: {
      newValue: newValue
    }
  };
}

function updateFollowingTeamStatus(newValue) {
  return {
    type: _actionTypes.UPDATE_FOLLOWING_STATUS,
    payload: {
      newValue: newValue
    }
  };
}

function updateShowTeammates(showTeammates) {
  return {
    type: _actionTypes.UPDATE_SHOW_TEAMMATES_STATUS,
    payload: {
      showTeammates: showTeammates
    }
  };
}

function isFollowingTeam() {
  return function (dispatch, getState) {
    var userIsFollowingTeam = true;
    var teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];
    var userFollows = getState().follow.userFollows;

    teammates.forEach(function (athlete) {
      var userId = athlete.feedUserId.type + '-' + athlete.feedUserId.relatedId;
      var isFollowing = userFollows[userId];
      if (!athlete.isFollowing && !isFollowing) {
        userIsFollowingTeam = false;
      }
    });
    return userIsFollowingTeam;
  };
}

function isNotFollowingTeam() {
  return function (dispatch, getState) {
    var userIsFollowingTeam = false;
    var teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];
    var userFollows = getState().follow.userFollows;

    teammates.forEach(function (athlete) {
      var userId = athlete.feedUserId.type + '-' + athlete.feedUserId.relatedId;
      var isFollowing = userFollows[userId];
      if (athlete.isFollowing || isFollowing) {
        userIsFollowingTeam = true;
      }
    });

    return !userIsFollowingTeam;
  };
}

function checkForFollowingTeamUpdates() {
  return function (dispatch, getState) {
    var hasMoreTeammates = getState().featuredAthletes.contentFeatureAthletes.hasMoreTeammates;
    var currentFollowStatus = getState().featuredAthletes.contentSuggestionsWidget.isFollowingTeam;
    var userIsFollowingTeam = dispatch(isFollowingTeam());
    var userIsNotFollowingTeam = dispatch(isNotFollowingTeam());

    if (!hasMoreTeammates) {
      if (!currentFollowStatus && userIsFollowingTeam) {
        dispatch(updateFollowingTeamStatus(true));
      } else if (currentFollowStatus && userIsNotFollowingTeam) {
        dispatch(updateFollowingTeamStatus(false));
      } else {
        dispatch(shouldCheckForFollowingTeamUpdates(false));
      }
    } else {
      dispatch(shouldCheckForFollowingTeamUpdates(false));
    }
  };
}

function getSuggestedAthletes(onlyTeammates, excludedAthleteIds, maxScore, count) {
  return function (dispatch, getState) {
    var requestData = {
      onlyTeammates: onlyTeammates,
      excludeAthleteIds: excludedAthleteIds,
      maxScore: maxScore,
      count: count
    };

    var type = onlyTeammates ? _actionTypes.UPDATE_IS_FETCHING_ATHLETES : _actionTypes.UPDATE_IS_FETCHING_SUGGESTIONS;
    type = count ? type : _actionTypes.UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS;
    dispatch(updateIsFetchingStatus(type, true));

    _services2.default.getSuggestedAthletes(requestData).fail(function () {
      return dispatch(failReceivedSuggestedAthlete());
    }).done(function (responseData) {
      var athletes = responseData;

      athletes.forEach(function (athlete) {
        excludedAthleteIds.push(athlete.feedUserId.relatedId);

        // The `positions` property is already formatted as a string.
        // Most other endpoints return an array of strings, so we'll
        // need to accommodate this with an additional PropType.
        athlete.formattedPositions = athlete.positions;
        delete athlete.positions;
      });

      if (onlyTeammates) {
        var userIsFollowingTeam = getState().featuredAthletes.contentSuggestionsWidget.isFollowingTeam || false;

        if (userIsFollowingTeam) {
          // Update the follow status for each user to ensure we have the latest state
          athletes.forEach(function (_ref) {
            var feedUserId = _ref.feedUserId;
            var feedUserType = feedUserId.type,
                feedUserRelatedId = feedUserId.relatedId;

            dispatch((0, _actionCreators.setUserFollow)(feedUserType, feedUserRelatedId, true));
          });
        }

        var previousTeammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];
        var newTeammates = previousTeammates.concat(athletes);
        var hasMore = athletes.length === count;
        var showTeammates = newTeammates.length !== 0;

        dispatch(receiveTeammates(newTeammates, hasMore, showTeammates));
      } else {
        if (athletes.length > 0) {
          var newMaxScore = athletes[athletes.length - 1].score;

          if (count) {
            dispatch(receiveModalSuggestedAthletes(athletes));
          } else {
            dispatch(receiveSuggestedAthletes(athletes, newMaxScore));
          }
        } else {
          dispatch(updateHasMoreSuggestions(false));
        }
      }

      dispatch(updateIsFetchingStatus(type, false));
    });
  };
}

function getSearchAthletes(athleteName, isFromModal) {
  return function (dispatch) {
    if (athleteName === '' && !isFromModal) {
      dispatch(receiveSearchAthletes([], false));
    } else {
      var requestData = {
        query: athleteName
      };

      _services2.default.searchAthlete(requestData).fail(function () {
        return dispatch(failReceivedSearchAthletes());
      }).done(function (responseData) {
        var athleteResults = responseData.athleteResults;


        if (isFromModal) {
          dispatch(receiveModalSearchAthletes(athleteResults, athleteName));
        } else {
          dispatch(receiveSearchAthletes(athleteResults, athleteName, true));
        }
      });
    }
  };
}

function followTeam() {
  return function (dispatch, getState) {
    var requestData = {
      includeAthletes: true,
      logData: { Origin: 'SuggestedFollowers' }
    };

    _services2.default.followTeam(requestData).fail(function () {
      return dispatch(failFollowTeam());
    }).done(function () {
      var teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];

      // Update the follow status for each user to ensure we have the latest state
      teammates.forEach(function (_ref2) {
        var feedUserId = _ref2.feedUserId;
        var feedUserType = feedUserId.type,
            feedUserRelatedId = feedUserId.relatedId;

        dispatch((0, _actionCreators.setUserFollow)(feedUserType, feedUserRelatedId, true));
      });

      dispatch(updateFollowingTeamStatus(true));
    });
  };
}

function unfollowTeam() {
  return function (dispatch, getState) {
    var requestData = {
      includeAthletes: true,
      logData: { Origin: 'SuggestedFollowers' }
    };

    _services2.default.unfollowTeam(requestData).fail(function () {
      return dispatch(failUnfollowTeam());
    }).done(function () {
      var teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];

      // Update the follow status for each user to ensure we have the latest state
      teammates.forEach(function (_ref3) {
        var feedUserId = _ref3.feedUserId;
        var feedUserType = feedUserId.type,
            feedUserRelatedId = feedUserId.relatedId;

        dispatch((0, _actionCreators.setUserFollow)(feedUserType, feedUserRelatedId, false));
      });

      dispatch(updateFollowingTeamStatus(false));
    });
  };
}

function followUnfollowTeam() {
  return function (dispatch, getState) {
    var userIsFollowingTeam = getState().featuredAthletes.contentSuggestionsWidget.isFollowingTeam;
    if (userIsFollowingTeam) {
      dispatch(unfollowTeam());
    } else {
      dispatch(followTeam());
    }
  };
}